"use strict";

var Dispatcher = require('flux').Dispatcher;


var flux = new Dispatcher();

exports.register = function(callback) {
    return flux.register(callback);
};

exports.waitFor = function(ids) {
    return flux.waitFor(ids);
};

var dispatch = function(type, action = {}) {
    if (!type) {
        throw new Error('You forgot to specify type.');
    }

    if (process.env.NODE_ENV !== 'production') {
        if (action.error) {
            //console.error(type, action);
        } else {
           //console.log(type, action);
        }
    }

    flux.dispatch({ type, ...action });
};
exports.dispatch = dispatch;

/**
 * Dispatches three actions for an async operation represented by promise.
 */
exports.dispatchAsync = function(promise, types, action = {}) {
    const { request, success, failure } = types;
    dispatch(request, action);
    promise.then(
        data => dispatch(success, { ...action, data }),
        error => dispatch(failure, { ...action, error })
    );
};



/** WEBPACK FOOTER **
 ** ./modules/dispatcher/AppDispatcher.js
 **/